import { graphql } from 'gatsby';
import React from 'react';

export default function TextWithLogo({
  text,
  logo,
  className,
}: {
  text: string;
  logo: string;
  className?: string;
}) {
  return (
    <div className={`text-with-logo ${className}`}>
      <div
        className='text-with-logo__text'
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <img
        src={logo}
        alt='Company logo'
        className='text-with-logo__logo'
      />
    </div>
  );
}

export const textWithLogoFragment = graphql`
  fragment TextWithLogoFragment on TextWithLogo {
    _template
    text
    logo
  }
`;
